var render = function render(){var _vm=this,_c=_vm._self._c;return _c('graph-detail08-template',{attrs:{"board-ids":[239],"field-code":"workplace-material","com-group-list":_vm.comGroupList,"graph1-title":"전체 (원료·제조물 사업장) 비상대피 훈련 현황","graph2-title":"월별 (원료·제조물 사업장) 비상대피 훈련 현황","graph3-title":"기간별 (원료·제조물 사업장) 비상대피 훈련 현황","field-label":"원료·제조물 사업장","field-category-label":"구분"}})
}
var staticRenderFns = []

export { render, staticRenderFns }